import actionTypes from '../constants/action-types';

const setGlobals = (globals) => ({
  type: actionTypes.SET_GLOBALS,
  payload: {
    globals,
  },
});

export default setGlobals;
